import { Global } from "../classes/Global";
import { StringHelper } from "./StringHelper";
import { StorageHelper } from './StorageHelper';

export class PriceHelper {

  static getCompletePriceKey(key: string, priceHint: string, item: any, getRental: boolean): string {

    if (!item) {
      return "";
    }

    if (priceHint == "offerslist"){
      //For offers list, we want to be able to show rental price

      const mediaType = Global.getMediaType();
      const store = Global.getStore();

      let prefix = "p";
      let suffix = "";

      const buyRent = Global.getBuyRent();

      if (getRental || ((mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES || mediaType == Global.MOVIES) &&
      buyRent && buyRent.type == "rent") || (item.wishlistInfo && item.wishlistInfo.isMarkedAsRentalItem)){
        prefix = "rentalP";
      }
      if (mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES || mediaType == Global.SEASONS) {

        suffix = (item.has4K && store != Global.ITUNES) ? "4k" : item.priceHd ? "Hd" : "Sd";

        const listType = Global.getListType();
        const sort = StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), listType, StorageHelper.keys.sort);

        if(/*listType == Global.ON_SALE && */sort == Global.LATEST_PRICE_CHANGE) {
          //in this case we never want to use a price which is not sinking
          const currentPriceKey = prefix + "rice" + suffix;
          const beforePriceKey = prefix + "rice" + suffix + "Before";

          if(item[currentPriceKey] > item[beforePriceKey]) {
            suffix = item.priceHd ? "Hd" : "Sd";
          }

        }

      }

      return prefix + "rice" + suffix + key;
    }

    else if (priceHint == "home" || priceHint == "search") {
      if (item.price != null){
        return "price" + key;
      }
      else {
        return (item.priceHd ? "priceHd" : "priceSd") + key;
      }
    }

  }

  static formatPrice(price, currency: string, space: boolean = true, acceptZero: boolean = false, decimals: boolean = true): string {
    if (acceptZero || (price && price >= 0)) {
      //Make sure its always 2 digits after the comma
      const floatPrice = parseFloat(price);
      if (floatPrice && decimals){
        price = floatPrice.toFixed(2);
      }
      if (currency){

        if (currency == "USD") { return "$" + price; }
        else if (currency == "EUR") { return StringHelper.replacePointsWithCommas(price) + (space ? " €" : "€"); }
        else if (currency == "CAD") { return price + "$"; }
        else if (currency == "GBP") { return "£" + price; }
        else if (currency == "CHF") { return price + " CHF"; }
        else if (currency == "AUD") { return price + "$"; }
        else if (currency == "CNY") { return "¥" + price; }
        else if (currency == "INF") { return "₹ " + price; }
        else if (currency == "JPY") { return "¥" + price; }
        else if (currency == "PLN") { return StringHelper.replacePointsWithCommas(price) + "zł"; }
        else if (currency == "RUB") { return StringHelper.replacePointsWithCommas(price) + "₽"; }
        else if (currency == "TRY") { return "₺" + StringHelper.replacePointsWithCommas(price); }
        else if (currency == "DKK") { return price + " kr."; }
        else if (currency == "SEK") { return price + " kr"; }
        else if (currency == "BRL") { return "R$" + price; }
        else if (currency == "MXN") { return "$" + price; }
        else { return price; }

      }
      else {
        return price;
      }
    }
    else {
      return "";
    }
  }

  static formatPriceWithoutCurrency(price, currency: string): string {
    if (currency == "EUR") { return StringHelper.replacePointsWithCommas(price); }
    else if (currency == "PLN") { return StringHelper.replacePointsWithCommas(price); }
    else if (currency == "RUB") { return StringHelper.replacePointsWithCommas(price); }
    else if (currency == "TRY") { return StringHelper.replacePointsWithCommas(price); }
    else { return price; }
  }

  static getCurrencySymbol(currency: string): string {
    if (currency == "USD") { return "$"; }
    else if (currency == "EUR") { return "€"; }
    else if (currency == "CAD") { return "$"; }
    else if (currency == "GBP") { return "£"; }
    else if (currency == "CHF") { return "CHF"; }
    else if (currency == "AUD") { return "$"; }
    else if (currency == "CNY") { return "¥"; }
    else if (currency == "INF") { return "₹"; }
    else if (currency == "JPY") { return "¥"; }
    else if (currency == "PLN") { return "zł"; }
    else if (currency == "RUB") { return "₽"; }
    else if (currency == "TRY") { return "₺"; }
    else if (currency == "DKK") { return " kr."; }
    else if (currency == "SEK") { return " kr"; }
    else if (currency == "BRL") { return "R$"; }
    else { return ""; }
  }

  static hasPrice(item, buy) {
    if(buy && item.price != null) {
      return true;
    }
    if(!buy && item.rentalPrice) {
      return true;
    }
    return false;
  }

  static getCurrentDetailViewPrice(item: any, buy: boolean) {
    if(PriceHelper.hasSdPrice(item, buy) && !PriceHelper.hasHdPrice(item, buy)) {
      return PriceHelper.getSdPrice(item, buy);
    }
    else if(PriceHelper.hasHdPrice(item, buy)) {
      return PriceHelper.getHdPrice(item, buy);
    }
    else if(PriceHelper.has4kPrice(item, buy)) {
      return PriceHelper.get4kPrice(item, buy);
    }
    else if(PriceHelper.hasPrice(item, buy)) {
      return buy? PriceHelper.formatPrice(item.price, item.currency) : PriceHelper.formatPrice(item.rentalPrice, item.currency);
    }
    return "";
  }

  static get4kPrice(item, buy): string {
    if(!item) { return ''; }
    if(buy) {
      return PriceHelper.formatPrice(item.price4k, item.currency);
    }
    else {
      return PriceHelper.formatPrice(item.rentalPrice4k, item.currency);
    }
  }

  static getHdPrice(item, buy): string {
    if(!item) { return ''; }
    if(buy){
      return PriceHelper.formatPrice(item.priceHd, item.currency);
    }
    else {
      return PriceHelper.formatPrice(item.rentalPriceHd, item.currency);
    }
  }

  static getSdPrice(item, buy): string {
    if(!item) { return ''; }
    if(buy){
      return PriceHelper.formatPrice(item.priceSd, item.currency);
    }
    else {
      return PriceHelper.formatPrice(item.rentalPriceSd, item.currency);
    }
  }

  static has4kPrice(item, buy): boolean {
    if(buy && item.price4k) {
      return true;
    }
    if(!buy && item.rentalPrice4k) {
      return true;
    }
    return false;
  }

  static hasHdPrice(item, buy) {
    if(buy && item.priceHd) {
      return true;
    }
    if(!buy && item.rentalPriceHd) {
      return true;
    }
    return false;
  }

  static hasSdPrice(item, buy) {
    if(buy && item.priceSd) {
      return true;
    }
    if(!buy && item.rentalPriceSd) {
      return true;
    }
    return false;
  }

  static isBestPriceForItem(item: any): boolean {
    if (!item) return false;

    if (item.priceSdIsBest === 1 && !PriceHelper.hasHdPrice(item, true)) {
      return true;
    }

    if (item.priceHdIsBest === 1) {
      return true;
    }

    if (item.price4kIsBest === 1) {
      return true;
    }

    if (item.priceIsBest === 1) {
      return true;
    }

    return false;
  }

  static isLowestPriceForItem(item: any): boolean {
    if (!item) return false;

    if (item.priceSdIsLowest === 1 && !PriceHelper.hasHdPrice(item, true)) {
      return true;
    }

    if (item.priceHdIsLowest === 1) {
      return true;
    }

    if (item.price4kIsLowest === 1) {
      return true;
    }

    if (item.priceIsLowest === 1) {
      return true;
    }

    return false;
  }

  static getFirstReachedDate(item: any, price: number): string | null {
    if (!item) return null;

    // Priorisiere den Preisverlauf (SD nur, wenn kein HD vorhanden ist)
    let priceKey = null;
    if (PriceHelper.hasSdPrice(item, true) && !PriceHelper.hasHdPrice(item, true)) {
      priceKey = 'priceSdEvolution';
    } else if (PriceHelper.hasHdPrice(item, true)) {
      priceKey = 'priceHdEvolution';
    } else if (PriceHelper.has4kPrice(item, true)) {
      priceKey = 'price4kEvolution';
    } else if (PriceHelper.hasPrice(item, true)) {
      priceKey = 'priceEvolution';
    }

    if (!priceKey || !item[priceKey]) {
      return null;
    }

    const evolution = item[priceKey].split('~'); // Preisentwicklung als Array

    if (!evolution || evolution.length === 0) {
      return null; // Kein Preisverlauf vorhanden
    }

    // Iteriere von ALT nach NEU (daher Array umkehren)
    for (let i = evolution.length - 1; i >= 0; i--) {
      const entry = evolution[i];
      const [date, priceChange] = entry.split(':');

      if (!date || !priceChange) {
        continue; // Überspringe ungültige Einträge
      }

      const cleanedPrice = parseFloat(priceChange.replace(/[+-]/g, '')); // Entferne Vorzeichen und parse

      if (isNaN(cleanedPrice)) {
        continue; // Überspringe ungültige Preise
      }

      if (cleanedPrice === price) {
        return date; // Rückgabe des Datums, an dem der Preis erstmals erreicht wurde
      }
    }

    return null; // Preis wurde nie erreicht
  }


  static getPreviousPriceFromEvolution(priceEvolution: string): number | null {
    if (!priceEvolution) {
      return null;
    }

    const evolution = priceEvolution.split('~');
    const startIndex = evolution.length > 1 ? 1 : 0;
    for (let i = startIndex; i < evolution.length; i++) {
      const parts = evolution[i].split(':');
      if (!parts || parts.length < 2) {
        continue;
      }

      const price = parseFloat(parts[1].replace(/[+-]/g, ''));
      if (!isNaN(price)) {
        return price;
      }
    }

    return null;
  }

  static getFirstAvailablePreviousPriceFromEvolution(item: any, keys: Array<string>): number | null {
    if (!item || !keys) {
      return null;
    }

    for (let i = 0; i < keys.length; i++) {
      const price = PriceHelper.getPreviousPriceFromEvolution(item[keys[i]]);
      if (price !== null) {
        return price;
      }
    }

    return null;
  }

  static getLowestPriceInfo(item: any): { lowestPrice: number, date: string, timesReached: number } | false {
    if (!item) {
      return false;
    }

    let priceKey = null;
    if (PriceHelper.hasSdPrice(item, true) && !PriceHelper.hasHdPrice(item, true)) {
      priceKey = 'priceSdEvolution';
    } else if (PriceHelper.hasHdPrice(item, true)) {
      priceKey = 'priceHdEvolution';
    } else if (PriceHelper.has4kPrice(item, true)) {
      priceKey = 'price4kEvolution';
    } else if (PriceHelper.hasPrice(item, true)) {
      priceKey = 'priceEvolution';
    }

    if (!priceKey || !item[priceKey]) {
      return false;
    }

    const evolution = item[priceKey].split('~');
    if (evolution.length <= 1) {
      return false; // Kein Verlauf, nur ein Preis
    }

    let lowestPrice = Number.MAX_VALUE;
    let lowestDate = '';
    let timesReached = 0;

    evolution.forEach(entry => {
      const [date, priceChange] = entry.split(':');
      const price = parseFloat(priceChange.replace(/[+-]/g, ''));

      if (isNaN(price)) {
        console.error(`[Debug] Invalid price entry: ${entry}`);
        return;
      }

      if (price < lowestPrice) {
        lowestPrice = price;
        lowestDate = date;
        timesReached = 1; // Reset counter, weil neuer niedrigster Preis
      } else if (price === lowestPrice) {
        timesReached++; // Zähler erhöhen
      }
    });

    return {
      lowestPrice,
      date: lowestDate,
      timesReached,
    };
  }


  static getRelevantPrice(item: any, buy: boolean): { price: number, type: string, isPriceDrop: boolean } | null {
    if (!item) return null;

    const getPriceAsFloat = (price: number): number => parseFloat(price.toFixed(2));

    // Helper: Prüft, ob es einen Preisabfall gab
    const isPriceDrop = (priceDropIndicator: number): boolean => priceDropIndicator === -1;

    if (PriceHelper.hasSdPrice(item, buy) && !PriceHelper.hasHdPrice(item, buy)) {
      const sdPrice = getPriceAsFloat(item.priceSd);
      const priceDrop = isPriceDrop(item.priceSdDropIndicator);
      return { price: sdPrice, type: 'SD', isPriceDrop: priceDrop };
    } else if (PriceHelper.hasHdPrice(item, buy)) {
      const hdPrice = getPriceAsFloat(item.priceHd);
      const priceDrop = isPriceDrop(item.priceHdDropIndicator);
      return { price: hdPrice, type: 'HD', isPriceDrop: priceDrop };
    } else if (PriceHelper.has4kPrice(item, buy)) {
      const k4Price = getPriceAsFloat(item.price4k);
      const priceDrop = isPriceDrop(item.price4kDropIndicator);
      return { price: k4Price, type: '4K', isPriceDrop: priceDrop };
    } else if (PriceHelper.hasPrice(item, buy)) {
      const genericPrice = getPriceAsFloat(buy ? item.price : item.rentalPrice);
      const priceDrop = isPriceDrop(buy ? item.priceDropIndicator : item.rentalPriceDropIndicator);
      return { price: genericPrice, type: 'Default', isPriceDrop: priceDrop };
    }
    return null;
  }







}
